import PropTypes from 'prop-types';
import React from 'react';

class CardLink extends React.Component {
  handleOnClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  render() {
    return (
      <div onClick={this.handleOnClick} className="link-card-container">
        <div className="link-card-content text-center">
          <div className="circle-icon m-auto d-flex text-center">
            <i className={`${this.props.iconClass} m-auto`} />
          </div>
          <p>{this.props.description}</p>
        </div>
      </div>
    );
  }
}

CardLink.propTypes = {
  iconClass: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
};
export default CardLink;
